import { render, staticRenderFns } from "./inbound-text-message.vue?vue&type=template&id=68da2304"
import script from "./inbound-text-message.vue?vue&type=script&lang=js"
export * from "./inbound-text-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68da2304')) {
      api.createRecord('68da2304', component.options)
    } else {
      api.reload('68da2304', component.options)
    }
    module.hot.accept("./inbound-text-message.vue?vue&type=template&id=68da2304", function () {
      api.rerender('68da2304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/inbound-text-message.vue"
export default component.exports